
import { IconDefinition, library } from '@fortawesome/fontawesome-svg-core';
import { faStar as fasStar } from '@fortawesome/free-regular-svg-icons';
import { faStar as farSrar } from '@fortawesome/free-solid-svg-icons';
      library.add(fasStar as IconDefinition);
      library.add(farSrar as IconDefinition);
export default {
    name: 'RatingView',
    components : {
        
    },
    props: {
        'grade': {
            type : Number,
            default : 0
        },  
        'maxStars': {
            type : Number,
            default : 0
        }, 
        'hasCounter': {
            type : Boolean,
            default : true
        }, 
    },
    setup(props) {
        let stars; 
        console.log(props.grade,"data-=-=")
        function rate(star) {
            if (star <= props.maxStars && star >= 0) {
                stars = props.grade === star ? star - 1 : star;
            }
        }

        return {
            rate,
            stars
        }
    },
    // data() {
    //     return {
            
    //     }
    // },
 
}
